import type { TrackedOrderStage } from '@/services/orderTracking';

interface OrderTimelineProps {
  stages: TrackedOrderStage[];
  stageIndex: number;
  cancelled: boolean;
}

export default function OrderTimeline({ stages, stageIndex, cancelled }: OrderTimelineProps) {
  if (cancelled) {
    return (
      <div className="p-4 rounded-xl bg-red-50 border border-red-200 flex items-start gap-3">
        <div className="w-9 h-9 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
          <i className="ri-close-circle-line text-red-500 text-lg"></i>
        </div>
        <div>
          <p className="text-sm font-semibold text-red-700">Pedido cancelado</p>
          <p className="text-xs text-red-600 mt-0.5 leading-relaxed">
            Este pedido fue cancelado. Si crees que es un error, escríbenos por WhatsApp.
          </p>
        </div>
      </div>
    );
  }

  return (
    <ol className="relative">
      {stages.map((stage, index) => {
        const done = index < stageIndex;
        const current = index === stageIndex;
        const active = index <= stageIndex;
        return (
          <li key={stage.key} className="flex gap-3 last:pb-0 pb-5">
            <div className="flex flex-col items-center">
              <span
                className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
                  active ? 'bg-accent-500 text-white' : 'bg-background-100 text-foreground-400'
                }`}
              >
                {done ? (
                  <i className="ri-check-line text-sm"></i>
                ) : current ? (
                  <span className="w-2.5 h-2.5 rounded-full bg-white animate-pulse"></span>
                ) : (
                  <span className="w-2.5 h-2.5 rounded-full border-2 border-current"></span>
                )}
              </span>
              {index < stages.length - 1 && (
                <span className={`w-0.5 flex-1 my-1 ${done ? 'bg-accent-500' : 'bg-background-200'}`}></span>
              )}
            </div>
            <div className="pt-1.5">
              <p className={`text-sm ${active ? 'font-semibold text-foreground-950' : 'font-medium text-foreground-400'}`}>
                {stage.label}
              </p>
              {current && (
                <p className="text-xs text-accent-600 mt-0.5">Estado actual</p>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
}